import React, { useState } from 'react';
import { Pencil, Trash2, Save, X } from 'lucide-react';
import MappaZone from './MappaZone';
import { visiteAPI } from '../../services/api';

/**
 * ModuloZone
 * Contenitore dello schema tecnico "zone trattate" dentro una
 * procedura. Segue lo schema che avevano ModuloBotox e ModuloFiller (tolti il
 * 22 settembre 2026):
 * il modulo salva, la mappa disegna.
 */
const ModuloZone = ({ modulo, visitaId, onUpdate, sessoPaziente }) => {
    const [editing, setEditing] = useState(false);
    const [contenuto, setContenuto] = useState(modulo.contenuto || { mappa: null, punti: [] });
    const [salvataggio, setSalvataggio] = useState(false);

    const handleSave = async () => {
        setSalvataggio(true);
        try {
            await visiteAPI.updateModulo(modulo.id, { contenuto });
            setEditing(false);
            if (onUpdate) onUpdate();
        } catch (e) {
            console.error('Errore salvataggio zone trattate:', e);
        } finally {
            setSalvataggio(false);
        }
    };

    const handleDelete = async () => {
        if (!window.confirm('Eliminare questo schema?')) return;
        try {
            await visiteAPI.deleteModulo(modulo.id);
            if (onUpdate) onUpdate();
        } catch (e) {
            console.error('Errore eliminazione zone trattate:', e);
        }
    };

    return (
        <div className="modulo-box modulo-zone">
            <div className="modulo-header">
                <h3>{modulo.titolo || 'Zone trattate'}</h3>
                <div className="modulo-azioni">
                    {editing ? (
                        <>
                            <button onClick={handleSave} className="btn-save" disabled={salvataggio}>
                                <Save size={14} strokeWidth={1.8} aria-hidden="true" />
                                {salvataggio ? 'Salvataggio…' : 'Salva'}
                            </button>
                            <button onClick={() => { setContenuto(modulo.contenuto || { mappa: null, punti: [] }); setEditing(false); }}
                                    className="btn-cancel">
                                <X size={14} strokeWidth={1.8} aria-hidden="true" />
                            </button>
                        </>
                    ) : (
                        <>
                            <button onClick={() => setEditing(true)} className="btn-edit-small" title="Modifica">
                                <Pencil size={14} strokeWidth={1.8} aria-hidden="true" />
                            </button>
                            <button onClick={handleDelete} className="btn-delete-small" title="Elimina">
                                <Trash2 size={14} strokeWidth={1.8} aria-hidden="true" />
                            </button>
                        </>
                    )}
                </div>
            </div>

            <MappaZone
                data={contenuto}
                onChange={setContenuto}
                readOnly={!editing}
                sessoPaziente={sessoPaziente}
            />
        </div>
    );
};

export default ModuloZone;
